import { SkeletonWrapper } from 'modules/campaignAnalytics/components/Styled';
import { Skeleton } from 'ui/skeleton';

export const LoadingCard = ({ height }: { height: number }) => {
  return (
    <SkeletonWrapper height={height} padding={24}>
      <Skeleton />
    </SkeletonWrapper>
  );
};
